<template>
    <v-flex>
        <v-flex class="test__textarea-wrap ma-0"
                :class="{'correct': ifCorrect,
                         'wrong': ifWrong,
                         'pa-0': !resultsLayout}"
        >
            <div class="grey-text mb-2">{{$t("Введите ответ на вопрос")}}</div>
            <textareaBase :id="question_number" v-bind="$attrs"
                          :placeholder="$t('Введите текст')"
                          class="test__textarea"
                          :name="'text_field'+question_number"
                          :value='questions[question_number].variants[0].selected'
                          @input="$emit('change', $event.target.value)"
            />
            <v-flex v-if="ifCorrect"
                    class="question__check-wrap"
            >
                <svg v-svg
                     symbol="ok"
                     class="question__check"
                     role="presentation"
                />
            </v-flex>
            <v-flex v-if="ifWrong"
                    class="question__check-wrap question__check-wrap-wrong"
            >
                <svg v-svg
                     symbol="error"
                     class="question__check"
                     role="presentation"
                />
            </v-flex>
        </v-flex>
    </v-flex>
</template>

<script>
import textareaBase from '@/components/ui/inputs/base/textarea';
import {mapGetters} from 'vuex';
export default {
  components: {
    textareaBase,
  },
  computed: {
    ...mapGetters('testing/questions', [
      'questions',
      'question_image',
      'question_number',
      'questions',
      'stats',
    ]),
    ...mapGetters('testing', [
      'resultsLayout',
    ]),
    ifCorrect: function() {
      return this.resultsLayout && this.questions[this.question_number].variants[0].correct == this.questions[this.question_number].variants[0].selected;
    },
    ifWrong: function() {
      return this.resultsLayout && this.questions[this.question_number].variants[0].correct != this.questions[this.question_number].variants[0].selected;
    },
  },
  methods: {
    emit($event) {
      this.$emit('change', $event);
    },
  },
};
</script>

